"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPFSService = void 0;
const config_1 = require("@app/config");
const ipfs_http_client_1 = __importDefault(require("ipfs-http-client"));
const http_service_1 = require("./http.service");
const ipfs = new ipfs_http_client_1.default({
    host: config_1.CONFIG.ipfsBalancer,
    port: "443",
    protocol: "https",
});
class IPFSService extends http_service_1.HttpService {
    constructor() {
        super();
    }
    getIpfsData(cid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { object } = yield this.httpClient.get(`${config_1.CONFIG.ipfsServer}/${cid}`);
                return object === null || object === void 0 ? void 0 : object.data;
            }
            catch (error) {
                console.error("cloudflare ipfs failed", cid, error);
                throw new Error("File in IPFS was not found cid:" + cid);
            }
        });
    }
    uploadFileToIpfs(file) {
        return __awaiter(this, void 0, void 0, function* () {
            if (file) {
                try {
                    let resolver = undefined;
                    let rejecter = undefined;
                    const promise = new Promise((resolve, reject) => {
                        resolver = resolve;
                        rejecter = reject;
                    });
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onloadend = () => resolver === null || resolver === void 0 ? void 0 : resolver(reader);
                    reader.onerror = (e) => rejecter === null || rejecter === void 0 ? void 0 : rejecter(e);
                    reader.onabort = (e) => rejecter === null || rejecter === void 0 ? void 0 : rejecter(e);
                    const loadedReader = yield promise;
                    const [{ path }] = yield ipfs.add(Buffer.from(loadedReader.result));
                    return path;
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                    throw new Error("File in IPFS was not loaded");
                }
            }
            return "";
        });
    }
}
exports.IPFSService = IPFSService;
